exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "th.report-column[data-v-3f10bebf]{position:relative;cursor:pointer;padding:10px 20px 10px 15px}th.report-column span[data-v-3f10bebf]{position:absolute;right:7px;display:flex;flex-direction:column;justify-content:center;align-items:center;top:50%;transform:translateY(-50%)}th.report-column span ion-icon[data-v-3f10bebf]{height:15px;font-size:10px}th.report-column span ion-icon[data-v-3f10bebf]:nth-child(2){margin-top:-8px}", ""]);

// exports
